import utility from './utility'
import styleSelect from './styleSelect'
import lotteryTabs from './lotteryTabs'

const lotteryResults = {
    init: function() {
        const _this = this;

        [...document.querySelectorAll(".result-search-form")].map(searchForm => {
            searchForm.onsubmit = (el) => {
                window.location.href = el.target.querySelector("select").value;
                return false;
            };
        });

        _this.resultExpandClick();
        _this.initMultiplierSelect();

        const dateSelector = document.getElementById("lottery-results--draw-dates");
        if (dateSelector) {
            dateSelector.onchange = (e) => {
                lotteryResults.loadResultsDetails(e.currentTarget);
            };
        }


        const resultsActions = [...document.querySelectorAll(".results-nav-action")];
        resultsActions.map(resultsAction => {
            resultsAction.onclick = (e) => {
                const resultAction = e.currentTarget.dataset.action;
                resultAction == 'next' ? dateSelector.selectedIndex -= 1 : dateSelector.selectedIndex += 1;
                dateSelector.dispatchEvent(new Event('change'));
                dateSelector.nextElementSibling.querySelectorAll(".select-options > .select-option")
                const prevSelector = document.getElementById("results-nav-next");

                if (dateSelector.selectedIndex > 0) {
                    utility.removeClass(prevSelector, "v-hidden");
                } else {
                    utility.addClass(prevSelector, "v-hidden");
                }
                e.preventDefault();
            }
        });
    },
    initMultiplierSelect: function () {
        const multiplierSelect = document.querySelector("select[name='multiplier-select']");
        if (!multiplierSelect) return;

        // Make default option unselectable
        const defaultOption = multiplierSelect.querySelector('option[value=""]');
        if (defaultOption) {
            defaultOption.disabled = true;
        }

        // Set default value to "1" (Base prize) if no value is selected
        if (!multiplierSelect.value) {
            multiplierSelect.value = "1";
        }

        multiplierSelect.addEventListener('change', function () {
            let selectedValue = this.value === "0" ? "1" : this.value;
            // Hide all result containers
            document.querySelectorAll('[id^="results-multiplier-"]').forEach(div => {
                utility.removeClass(div, "active");
            });

            // Show selected container
            if (selectedValue) {               
               const multiplierResults = document.getElementById(`results-multiplier-${selectedValue}`);

               if (multiplierResults) {
                   utility.addClass(multiplierResults, "active");
               }
            }
        });

        // Trigger initial change event to show correct results
        multiplierSelect.dispatchEvent(new Event('change'));
    },
    loadResultsDetails: (select) => {
        if (select.selectedIndex < 0) {
            return;
        }

        const prevSelector = document.getElementById("results-nav-next");

        if (select.selectedIndex > 0) {
            utility.removeClass(prevSelector, "v-hidden");
        } else {
            utility.addClass(prevSelector, "v-hidden");
        }
        const selectedOption = select.options[select.selectedIndex];
        const ajaxOptions = {
            url: `/api/web/lottery/results?lotteryId=${selectedOption.dataset.lottery}&drawDate=${selectedOption.dataset.date}`,
            method: "GET",
            success: function (e) {
                document.getElementById("lottery-results--dynamic-content").innerHTML = e.target.responseText;
                lotteryTabs.init(document.getElementById("lottery-results--dynamic-content"));
                //reapply select dropdown styles / dropdown change event after each ajax partial update
                if (document.querySelector("#multiplier-select")) {
                    styleSelect.init("#multiplier-select");
                    lotteryResults.initMultiplierSelect();
                }
            }
        };
        utility.ajaxRequest(ajaxOptions);
    },

    resultExpandClick: () => {
        const resultExpands = [...document.querySelectorAll('.results-expand')];
        resultExpands.map(resultExpand => {
            lotteryResults.resultExpandItemClick(resultExpand);
        });
    },

    resultExpandItemClick: (resultExpand) => {
        var divisionResult;
        if (resultExpand.classList.contains('account-order-link')) {
            divisionResult = resultExpand.previousElementSibling;
        }
        else {
            divisionResult = resultExpand.nextElementSibling;
        }
        const expandText = resultExpand.innerHTML;
        const expandLessText = resultExpand.dataset.subtext;

        if (!divisionResult.classList.contains('results-content')) {
            return;
        }

        resultExpand.onclick = () => {
            utility.toggleClass(resultExpand, 'active');
            if (resultExpand.classList.contains('active')) {
                divisionResult.style.maxHeight = `${divisionResult.scrollHeight}px`

                //For system entry double sliders
                const parentResultsContainer = utility.findAncestor(resultExpand, "results-content")
                if (parentResultsContainer) {
                    const parentResultsContainerHeight = divisionResult.scrollHeight + parentResultsContainer.scrollHeight
                    divisionResult.classList.add("system-scroll");
                    parentResultsContainer.style.maxHeight = `${parentResultsContainerHeight}px`
                }
            }
            else {
                divisionResult.style.maxHeight = 0
            }

            if (expandLessText) {
                if (!resultExpand.classList.contains('active')) {
                    resultExpand.querySelector('span').innerHTML = expandText
                }
                else {
                    resultExpand.querySelector('span').innerHTML = expandLessText
                }
            }
        }
    }
}

export default lotteryResults


// WEBPACK FOOTER //
// ./assets/src/js/classes/lotteryResults.js